import { render, staticRenderFns } from "./FormChangePlatform.vue?vue&type=template&id=420b0a3d&scoped=true&"
import script from "./FormChangePlatform.vue?vue&type=script&lang=js&"
export * from "./FormChangePlatform.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./FormChangePlatform.vue?vue&type=style&index=1&id=420b0a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b0a3d",
  null
  
)

export default component.exports